'use es6';

import { CONTACT_PROPERTY } from '../../../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { EnumerationDisplayType } from 'customer-data-filters/filterQueryFormat/DisplayTypes';
import { PRIVACY_CONSENT, __PRIVACY_CONSENT } from '../ListSegConstants';
import DSFieldRecord from 'customer-data-filters/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import I18n from 'I18n';
import PropertyRecord from 'customer-data-objects/property/PropertyRecord';
import once from 'transmute/once';
export default once(() => DSFieldRecord({
  description: I18n.text('customerDataFilters.FilterEditor.specialOptionValues.privacyConsent.description'),
  displayType: EnumerationDisplayType,
  label: I18n.text('customerDataFilters.FilterEditor.specialOptionValues.privacyConsent.label'),
  name: __PRIVACY_CONSENT,
  referencedObjectType: PRIVACY_CONSENT,
  type: CONTACT_PROPERTY,
  wrappedObject: PropertyRecord({
    description: I18n.text('customerDataFilters.FilterEditor.specialOptionValues.privacyConsent.description'),
    label: I18n.text('customerDataFilters.FilterEditor.specialOptionValues.privacyConsent.label'),
    name: __PRIVACY_CONSENT,
    type: CONTACT_PROPERTY,
    groupName: 'privacy'
  })
}));